<template>
  <div id="app">
    <audio :src="audioPath" loop controls autoplay style="display:none;" id="bgAudio"></audio>
    <router-view/>
    <!--  style="display:none;" -->
    <!-- style="position:absolute;top:10000px;" -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      audioPath: require("@/assets/audio/bg_audio.mp3")
    };
  },
  mounted() {
    const that = this;
    window.audioBg = document.getElementById("bgAudio");
    function forceSafariPlayAudio() {
      audioBg.load();
      audioBg.play(); // iOS 7/8 仅需要 play 一下
    }
    // 触摸屏幕
    document.addEventListener("touchend", forceSafariPlayAudio, false);
    audioBg.addEventListener(
      "play",
      function() {
        document.removeEventListener("touchend", forceSafariPlayAudio, false);
      },
      false
    );
    if (
      typeof WeixinJSBridge == "object" &&
      typeof WeixinJSBridge.invoke == "function"
    ) {
      forceSafariPlayAudio();
    }
    // 微信打开
    document.addEventListener(
      "WeixinJSBridgeReady",
      function() {
        forceSafariPlayAudio();
      },
      false
    );
  }
};
</script>

